import { remove, create, fetchAllAggregators, edit } from 'api/aggregator';
import { REQUEST_SUCCESS, REQUEST_FAIL } from 'reducers/modal/actions';
import { getAllDevices } from 'reducers/device/actions';

export const GET_ALL_AGGREGATORS_SUCCESS = 'GET_ALL_AGGREGATORS_SUCCESS';
export const GET_ALL_AGGREGATORS_FAIL = 'GET_ALL_AGGREGATORS_FAIL';
export const DELETE_AGGREGATOR_SUCCESS = 'DELETE_AGGREGATOR_SUCCESS';
export const DELETE_AGGREGATOR_FAIL = 'DELETE_AGGREGATOR_FAIL';

export const CREATE_AGGREGATOR_SUCCESS = 'CREATE_AGGREGATOR_SUCCESS';
export const CREATE_AGGREGATOR_FAIL = 'CREATE_AGGREGATOR_FAIL';

export const EDIT_AGGREGATOR_FAIL = 'EDIT_AGGREGATOR_FAIL';
export const SET_ALL_AGGREGATORS_SUCCESS = 'SET_ALL_AGGREGATORS_SUCCESS';
export const SET_ALL_AGGREGATORS_FAIL = 'SET_ALL_AGGREGATORS_FAIL';

export const SET_INDIVIDUAL_AGGREGATOR_SUCCESS =
  'SET_INDIVIDUAL_AGGREGATOR_SUCCESS';
export const SET_INDIVIDUAL_AGGREGATOR_FAIL = 'SET_INDIVIDUAL_AGGREGATOR_FAIL';

export const getAllAggregators = () => async (dispatch, getState) => {
  try {
    let aggregators = await fetchAllAggregators();

    return dispatch({
      type: GET_ALL_AGGREGATORS_SUCCESS,
      data: aggregators
    });
  } catch (err) {
    // Redundant catch-throw, but maintaining this until we update polling
    throw err;
  }
};

export const duplicateAggregator =
  aggregatorId => async (dispatch, getState) => {
    try {
      dispatch({
        type: REQUEST_FAIL,
        message: `Aggregator with ID ${aggregatorId} already exists`
      });
    } catch (err) {
      return dispatch({
        type: CREATE_AGGREGATOR_FAIL,
        err
      });
    }
  };

export const createAggregator = aggregator => async (dispatch, getState) => {
  try {
    await create(aggregator);
    // NOTE: refetch aggregators and dispatch after create, will be revisited during polling epic
    await dispatch(getAllAggregators());
    dispatch({
      type: REQUEST_SUCCESS,
      message: `Aggregator ${aggregator.aggregatorId} create success`
    });
    return { aggregatorId: aggregator.aggregatorId };
  } catch (err) {
    dispatch({
      type: REQUEST_FAIL,
      message: `Aggregator ${aggregator.aggregatorId} create failed`
    });
    throw err;
  }
};

export const editAggregator =
  (updatedAggregator, aggregatorId) => async (dispatch, getState) => {
    try {
      await edit(updatedAggregator, aggregatorId);
      await dispatch(getAllAggregators());
      dispatch({
        type: REQUEST_SUCCESS,
        message: `Aggregator ${aggregatorId} edit success`
      });
    } catch (err) {
      let errMsg = `Aggregator ${aggregatorId} edit unsuccessful`;
      if (err.message === 'Invalid pIN') {
        errMsg = 'Registration Pin Invalid';
      }
      dispatch({
        type: REQUEST_FAIL,
        message: errMsg
      });
      throw err;
    }
  };

export const deleteAggregator = aggregatorId => async (dispatch, getState) => {
  try {
    await remove(aggregatorId);
    // NOTE: refetch aggregators and dispatch after create, will be revisited during polling epic
    const updatedAggregators = await dispatch(getAllAggregators());
    await dispatch(getAllDevices());
    dispatch({
      type: REQUEST_SUCCESS,
      message: `Aggregator ${aggregatorId} delete success`
    });
    return updatedAggregators;
  } catch (err) {
    dispatch({
      type: REQUEST_FAIL,
      message: `Aggregator ${aggregatorId} delete unsuccessful`
    });
    throw err;
  }
};

export const setAggregators = devices => async dispatch => {
  try {
    return dispatch({
      type: SET_ALL_AGGREGATORS_SUCCESS,
      data: devices
    });
  } catch (err) {
    // Redundant catch-throw, but maintaining this until we update polling
    throw err;
  }
};

export const setIndividualAggregator =
  individualAggregator => async (dispatch, getState) => {
    try {
      const aggregators = getState().aggregator.aggregators;
      const updatedAggregators = aggregators.map(aggregator => {
        if (aggregator.aggregatorId === individualAggregator.aggregatorId) {
          return individualAggregator;
        }
        return aggregator;
      });
      await dispatch({
        type: SET_INDIVIDUAL_AGGREGATOR_SUCCESS,
        data: updatedAggregators
      });
      return;
    } catch (err) {
      // Redundant catch-throw, but maintaining this until we update polling
      throw err;
    }
  };
